<template>
    <div>
<!--        <strong>{{ $_.get(activity, "actorUser.name") }}</strong> removed the task workflow-->
<!--        <strong>{{ $_.get(activity, "payload.name") }}</strong>.-->
        <span v-html="$t('notification.taskWorkflowDeleted', {user: $_.get(activity, 'actorUser.name'), workflow: $_.get(activity, 'payload.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "TaskWorkflowDeleted",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
